import { render, staticRenderFns } from "./VehicleSoftwareRegister.vue?vue&type=template&id=683365fe"
import script from "./VehicleSoftwareRegister.vue?vue&type=script&lang=js"
export * from "./VehicleSoftwareRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports